var render = function render(){var _vm=this,_c=_vm._self._c;return _c('catalog-table',{attrs:{"tableHeaders":_vm.crewHeaders,"tableData":_vm.crews,"tableFilters":_vm.crewFilters,"propsToSearch":_vm.crewSearchableProps,"actions":_vm.crewActions,"loading-content-props":_vm.loadingContentInfo,"pageSize":100,"hidePageSize":"","hideFooter":""}},[(_vm.$can('add', 'Crew', 'crew'))?_c('template',{slot:"search-toolbar-actions"},[_c('md-button',{staticClass:"md-success",on:{"click":_vm.addCrew}},[_c('span',{staticClass:"md-label"},[_c('md-icon',{staticClass:"material-icons"},[_vm._v("add")])],1),_vm._v("\n      Agregar\n    ")])],1):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Crews/index.vue